import { TimesheetProvider } from ".";
import { fetchTimesheetLog } from "../request-handler";

// Specific providers for convenience
export const TimesheetLogProvider = ({ date, children }) => {
  return (
    <TimesheetProvider
      date={date}
      filters={{ date }}
      requestHandler={fetchTimesheetLog}
      key={date}
    >
      {children}
    </TimesheetProvider>
  );
};
